// Taux de change ACTUALISÉS (corrects)
const exchangeRates = {
  MAD: {
    USD: 0.10,    // 1 MAD = 0.10 USD (CORRECT)
    EUR: 0.092,   // 1 MAD = 0.092 EUR (CORRECT)
    MAD: 1
  },
  USD: {
    MAD: 10.0,    // 1 USD = 10.0 MAD (CORRECT - inverse de 0.10)
    EUR: 0.92,    // 1 USD = 0.92 EUR (CORRECT)
    USD: 1
  },
  EUR: {
    MAD: 10.87,   // 1 EUR = 10.87 MAD (CORRECT - inverse de 0.092)
    USD: 1.09,    // 1 EUR = 1.09 USD (CORRECT)
    EUR: 1
  }
};

// Vérification des taux
console.log("🔍 Vérification des taux de change:");
console.log("1 MAD =", exchangeRates.MAD.USD, "USD");
console.log("1 MAD =", exchangeRates.MAD.EUR, "EUR");
console.log("1 USD =", exchangeRates.USD.MAD, "MAD");
console.log("1 EUR =", exchangeRates.EUR.MAD, "MAD");

// Mapping des devises par langue
const currencyByLanguage = {
  fr: 'EUR',      // Français → Euro
  en: 'USD',      // English → Dollar US
  ar: 'MAD',      // Arabe → Dirham Marocain
  es: 'EUR',      // Espagnol → Euro
  de: 'EUR'       // Allemand → Euro
};

// Symboles des devises
const currencySymbols = {
  MAD: 'MAD',
  USD: '$',
  EUR: '€'
};

// Formattage par langue
const currencyFormats = {
  MAD: (price) => `${price} MAD`,      // 100 MAD
  USD: (price) => `$${price}`,         // $10.00
  EUR: (price) => `${price} €`         // 9.20 €
};

/**
 * Convertit un prix d'une devise à une autre
 */
export const convertPrice = (price, fromCurrency, toCurrency) => {
  if (!price || isNaN(price)) {
    console.warn("❌ Prix invalide:", price);
    return null;
  }
  
  const numericPrice = parseFloat(price);
  
  if (fromCurrency === toCurrency) {
    return numericPrice;
  }
  
  const rate = exchangeRates[fromCurrency]?.[toCurrency];
  if (!rate) {
    console.warn(`❌ Taux de change non trouvé: ${fromCurrency} -> ${toCurrency}`);
    return numericPrice;
  }
  
  const converted = parseFloat((numericPrice * rate).toFixed(2));
  
  console.log(`💰 Conversion: ${numericPrice} ${fromCurrency} -> ${converted} ${toCurrency} (taux: ${rate})`);
  
  return converted;
};

/**
 * Obtient la devise pour une langue donnée
 */
export const getCurrencyForLanguage = (language) => {
  const currency = currencyByLanguage[language] || 'EUR';
  console.log(`🌍 Langue "${language}" -> Devise: ${currency}`);
  return currency;
};

/**
 * Obtient le symbole de devise pour une langue donnée
 */
export const getCurrencySymbolForLanguage = (language) => {
  const currency = getCurrencyForLanguage(language);
  return currencySymbols[currency] || currency;
};

/**
 * Formate un prix avec la devise selon la langue
 */
export const formatPrice = (price, language, originalCurrency = 'MAD') => {
  if (!price || isNaN(price)) {
    return 'Price not available';
  }
  
  const numericPrice = parseFloat(price);
  const targetCurrency = getCurrencyForLanguage(language);
  
  console.log(`🎯 Formatage prix: ${numericPrice} ${originalCurrency} -> ${targetCurrency} (langue: ${language})`);
  
  // Si la devise cible est la même que l'originale, pas de conversion
  if (targetCurrency === originalCurrency) {
    const formatted = currencyFormats[targetCurrency]?.(numericPrice) || `${numericPrice} ${targetCurrency}`;
    console.log(`✅ Prix formaté (pas de conversion): ${formatted}`);
    return formatted;
  }
  
  // Conversion nécessaire
  const convertedPrice = convertPrice(numericPrice, originalCurrency, targetCurrency);
  
  if (!convertedPrice) {
    const fallback = currencyFormats[originalCurrency]?.(numericPrice) || `${numericPrice} ${originalCurrency}`;
    console.log(`⚠️  Utilisation fallback: ${fallback}`);
    return fallback;
  }
  
  const formatted = currencyFormats[targetCurrency]?.(convertedPrice) || `${convertedPrice} ${targetCurrency}`;
  console.log(`✅ Prix final: ${formatted}`);
  
  return formatted;
};

/**
 * Met à jour les taux de change (à appeler périodiquement)
 */
export const updateExchangeRates = async () => {
  try {
    // Vous pouvez intégrer une API de taux de change ici
    // Exemple avec une API gratuite:
    const response = await fetch('https://api.exchangerate-api.com/v4/latest/MAD');
    if (response.ok) {
      const data = await response.json();
      console.log('📊 Taux de change mis à jour depuis API:', data.rates);
      // Implémentez la mise à jour des exchangeRates ici
    }
    return true;
  } catch (error) {
    console.log('ℹ️  Utilisation des taux de change fixes');
    return false;
  }
};

// Test des conversions
console.log("🧪 Tests de conversion:");
console.log("100 MAD -> USD:", convertPrice(100, 'MAD', 'USD')); // Devrait donner ~10 USD
console.log("100 MAD -> EUR:", convertPrice(100, 'MAD', 'EUR')); // Devrait donner ~9.20 EUR
console.log("10 USD -> MAD:", convertPrice(10, 'USD', 'MAD'));   // Devrait donner ~100 MAD
console.log("10 EUR -> MAD:", convertPrice(10, 'EUR', 'MAD'));   // Devrait donner ~108.70 MAD

// Export par défaut
export default {
  convertPrice,
  getCurrencyForLanguage,
  getCurrencySymbolForLanguage,
  formatPrice,
  updateExchangeRates
};